import {Branch, BranchWithAssignedBrand} from "../../model/Branch";
import {IComponentController, IComponentOptions, IRootElementService, IScope} from "angular";
import {BranchesService} from "../../../branches_service/service/branches-service";
import {BranchesServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {Brand} from "../../../brand_service/model/Brand";
import {
    BrandConfigurationDialogComponent
} from "../../../brand/component/brand_configuration_dialog/brand-configuration-dialog.component";
import {UnassignedBrandsTitle} from "../../route/BranchRouteController";
import './brand-branches.component.scss'
import {DeleteBrandDialogComponent} from "../brand-delete/delete.brand.dialog.component";
import {EditBranchDialog} from "../branch-edit/edit-branch.dialog.component";

export class BrandBranch {
    brand: string;
    branches: Branch[];
}

export class BrandBranchesComponent implements IComponentController {

    private lastBranchesState: BrandBranch[];
    private brands: Brand[];
    private brandBranches: BrandBranch[];
    private unassignedBrandsTitle: string = UnassignedBrandsTitle;

    static instance: IComponentOptions = {
        template: require('./brand-branches.component.html'),
        controller: [
            '$scope',
            '$element',
            BranchesServiceName,
            ToastNotificationServiceName,
            'dragularService',
            '$mdDialog',
            BrandBranchesComponent
        ],
        bindings: {
            brandBranches: '<',
            brands: '<'
        }
    };
    private drake: any;

    constructor(private $scope: IScope,
                private $element: IRootElementService,
                private branchService: BranchesService,
                private toastNotificationService: ToastNotificationService,
                private dragularService: any,
                private $mdDialog: angular.material.IDialogService) {
    }

    $onInit(): void {
        this.lastBranchesState = BrandBranchesComponent.createCopy(this.brandBranches);
    }


    $postLink = () => {
        setTimeout(() => {
            this.initializeDragular();
        }, 100);

    };

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let changes = onChangesObj['brandBranches'];
        if (changes && !changes.isFirstChange()) {
            this.brandBranches = changes.currentValue;
            this.lastBranchesState = changes.previousValue;
        }
    }

    openEditBrandModal = ($event: MouseEvent, brandName: string) => {
        let brand = this.brands.find(brand => brand.name === brandName);
        this.$mdDialog.show(BrandConfigurationDialogComponent.instance($event, brand))
            .then(brandUpdate => {
                let brandBranch = this.brandBranches.find(bb => bb.brand === brandName);
                brandBranch.brand = brandUpdate.name;
                brandBranch.branches.map(branch => {
                    branch.brandName = brandUpdate.name;
                });
                brand = brandUpdate;
            });
    };

    public openDeleteBrandModal(bb: BrandBranch) {
        let brandName = bb.brand;
        let brand = this.brands.find(brand => brand.name === brandName);
        this.$mdDialog.show(DeleteBrandDialogComponent.instance(brand))
            .then((deletedBrand: Brand) => {
                bb.branches.map(branch => {
                    branch.brandName = UnassignedBrandsTitle;
                });
                let unassignedBrandBranch = this.brandBranches.find(bb => bb.brand === UnassignedBrandsTitle);
                unassignedBrandBranch.branches.push.apply(unassignedBrandBranch.branches, bb.branches);
                this.brandBranches = this.brandBranches.filter(brandBranch => brandBranch.brand != bb.brand);
                this.brands = this.brands.filter(brand => brand.name != deletedBrand.name);
            });
    }

    initializeDragular = () => {
        let listsElements = this.$element.find('branch-list');
        let justBranches = this.brandBranches.map(bb => bb.branches);
        this.drake = this.dragularService(listsElements, {
            scope: this.$scope,
            containersModel: justBranches
        });

        this.$scope.$on('dragulardrop', (e, el) => {
            e.stopPropagation();
            let brandBranches = this.brandBranches;
            this.findUpdatedBrunch(brandBranches);
        });
    };


    findUpdatedBrunch = (brandBranches: BrandBranch[]) => {
        brandBranches.forEach(bb => {
            let brandName = bb.brand;
            this.findUpdatedBranchInBrand(brandName, brandBranches);
        });
    };

    findUpdatedBranchInBrand = (brandName: string,
                                brandBranches: BrandBranch[]) => {
        let previousState = this.findBranchesByBrandName(brandName, this.lastBranchesState);
        let newState = this.findBranchesByBrandName(brandName, brandBranches);
        if (newState.length > previousState.length) {
            let brandNewBranches: Branch[] = newState.diff(previousState);
            brandNewBranches.forEach(branch => this.assignBranchToBrand(branch, brandName));
        }
    };

    assignBranchToBrand = (branch: Branch,
                           brandName: string) => {
        this.branchService.changeBranchBrand(brandName, branch)
            .then((resp) => {
                if (resp.status === 200) {
                    console.log("Branch {} has been moved to the brand {}", branch.branchName, brandName);
                    this.toastNotificationService.generateSuccessMessage("Successfully changed the branch brand!")
                }
            }, err => {
                this.toastNotificationService.generateErrorMessage("Failed to change the branch brand!")
            });
    };

    private static createCopy(brandBranches: BrandBranch[]) {
        let copy = [];
        for (let brandBranch of brandBranches) {
            copy.push({
                brand: brandBranch.brand,
                branches: brandBranch.branches.slice()
            });
        }
        return copy;
    }

    static k = 0;

    public openNewBrandDialog($event: MouseEvent) {
        this.$mdDialog.show(BrandConfigurationDialogComponent.instance($event, new Brand()))
            .then((brand: Brand) => this.pushNewBrand(brand))
            .then(bb => this.pushBranchesListToDragular(bb.branches));
    }

    private pushNewBrand(brand: Brand): Promise<BrandBranch> {

        this.brands.push(brand);
        let unassignedBrandBranch = this.brandBranches.pop();
        let bb = {
            brand: brand.name, branches: []
        };
        this.brandBranches.push(bb, unassignedBrandBranch);
        this.lastBranchesState = BrandBranchesComponent.createCopy(this.brandBranches);
        return new Promise((resolve) => {
            return resolve(bb)
        })
    }

    private pushBranchesListToDragular(branches: Branch[]) {
        let listsElements = this.$element.find('branch-list');
        this.drake.addContainers(listsElements);
        let lastDragularCommonIndex = this.drake.containersCtx.dragularCommon.length - 1;
        this.drake.containersCtx.dragularCommon[lastDragularCommonIndex].m = branches;
    }

    private findBranchesByBrandName = (brandName: string, brandBranches: BrandBranch[]): Branch[] => {
        return brandBranches.find(bb => bb.brand == brandName).branches;
    };

    public openNewBranchDialog(brandName: string) {

        let brand = this.brands.find(brand => brand.name === brandName);
        let branch = new BranchWithAssignedBrand();
        branch.brandName = brandName;
        branch.assignedBrand = brand;

        this.$mdDialog.show(EditBranchDialog.instance(branch))
            .then((branch: Branch) => {
                this.branchService.save(branch)
                    .then(resp => {
                        if (resp.status == 200) {
                            let branch = (<Branch>resp.data);
                            this.findBranchesByBrandName(brandName, this.brandBranches).push(branch);
                            this.toastNotificationService.generateSuccessMessage("New branch added");
                        }
                    });
            });
    }

    public isUnassignedBrand(brandName: string) {
        return brandName === UnassignedBrandsTitle;
    }
}